import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { MobileOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../api/auth';
import { safeLoginRedirect } from '../utils/auth';
import Footer from '../components/common/Footer';
import '../styles/Login.css';

const { Title } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const reason = sessionStorage.getItem('auth:logoutReason');
      if (reason) {
        sessionStorage.removeItem('auth:logoutReason');
        message.warning(reason);
      }
    } catch (_) {}
  }, []);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await login(values.phone, values.password);

      // 确保数据已保存到localStorage
      if (response.data.token) {
        message.success('登录成功！');

        // 使用安全的登录跳转函数
        await safeLoginRedirect('/account/students/formal', navigate);
      } else {
        throw new Error('登录响应中缺少token');
      }
    } catch (error) {
      console.error('登录失败:', error);
      // 清理可能写入的部分登录信息，保持状态一致
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // 处理不同类型的错误
      if (error.message === '您没有权限登录经销商端') {
        message.error('您没有权限登录经销商端，请使用经销商账号');
      } else if (error.message === '登录状态验证失败') {
        message.error('登录状态验证失败，请重试');
      } else if (error.message === '登录信息保存失败') {
        message.error('登录信息保存失败，请重试');
      } else if (error.response?.status === 400) {
        // 处理400错误，通常是用户不存在或密码错误
        const errorMessage = error.response?.data || '登录失败';
        if (typeof errorMessage === 'string') {
          if (errorMessage.includes('用户不存在')) {
            message.error('该手机号未注册，请检查手机号是否正确或联系管理员');
          } else if (errorMessage.includes('密码错误') || errorMessage.includes('Bad credentials')) {
            message.error('密码错误，请检查密码是否正确');
          } else if (errorMessage.includes('账号已过期')) {
            message.error('账号已过期，请联系管理员续期');
          } else if (errorMessage.includes('被禁用')) {
            message.error('账号已被禁用，请联系管理员');
          } else {
            message.error(errorMessage);
          }
        } else {
          message.error('登录失败，请检查手机号和密码');
        }
      } else if (error.response?.status === 401) {
        message.error('认证失败，请检查手机号和密码');
      } else if (error.response?.status === 403) {
        message.error('您没有权限访问该系统');
      } else if (error.response?.status >= 500) {
        message.error('服务器错误，请稍后重试');
      } else {
        message.error('登录失败: ' + (error.response?.data || error.message || '网络错误'));
      }
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <Title level={2} className="login-title">
          经销商后台系统
        </Title>
        <Form
          name="login_form"
          className="login-form"
          onFinish={onFinish}
          size="large"
        >
          <div className="input-label">请输入手机号</div>
          <Form.Item
            name="phone"
            rules={[
              { required: true, message: '请输入手机号!' },
              { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码!' }
            ]}
          >
            <Input
              prefix={<MobileOutlined className="input-icon" />}
              placeholder="请输入手机号"
            />
          </Form.Item>

          <div className="input-label">请输入密码</div>
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码!' }]}
          >
            <Input.Password
              prefix={<LockOutlined className="input-icon" />}
              placeholder="请输入密码"
              iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="login-button"
            >
              登 录
            </Button>
          </Form.Item>
          
        </Form>
      </div>
      <Footer />
    </div>
  );
};

export default Login; 
